// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.idcard-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}

.idcard-title {
  padding: 16px;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: var(--text-primary);
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
}

.idcard-content {
  flex: 1 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.idcard-block {
  display: flex;
  flex-direction: column;
}

.idcard-label {
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 600;
  margin-bottom: 8px;
}

.idcard-img {
  width: 100%;
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
  object-fit: contain;
  max-height: 60vh;
  cursor: zoom-in;
}

.idcard-empty {
  width: 100%;
  min-height: 200px;
  border: 1px dashed var(--border-light);
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
}`, "",{"version":3,"sources":["webpack://./src/components/IdCardImagePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;AAChC","sourcesContent":[".idcard-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-primary);\n}\n\n.idcard-title {\n  padding: 16px;\n  font-size: 18px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-primary);\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.idcard-content {\n  flex: 1;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.idcard-block {\n  display: flex;\n  flex-direction: column;\n}\n\n.idcard-label {\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.idcard-img {\n  width: 100%;\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n  object-fit: contain;\n  max-height: 60vh;\n  cursor: zoom-in;\n}\n\n.idcard-empty {\n  width: 100%;\n  min-height: 200px;\n  border: 1px dashed var(--border-light);\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
